import type {
  PrivacyService,
  ConsentState,
} from "../types/index";


export function getService(
  services: PrivacyService[],
  serviceId: string
): PrivacyService | undefined {

  return services.find(
    service =>
      service.id === serviceId
  );

}



export function hasServiceConsent(
  service: PrivacyService,
  consent: ConsentState
): boolean {


  if(service.category === "necessary"){

    return true;

  }


  return consent[
    service.category
  ];

}



export function getServicesByCategory(
  services: PrivacyService[],
  category: string
){

  return services.filter(
    service =>
      service.category === category
  );

}